import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { Mail, Building, Phone, Calendar } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ContactsView = ({ auth }) => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContacts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchContacts = async () => {
    try {
      const response = await axios.get(`${API}/admin/contacts`, {
        auth: { username: auth.username, password: auth.password }
      });
      setContacts(response.data?.items || response.data || []);
    } catch {
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      data-testid="contacts-view"
    >
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-white mb-2">Mensajes de Contacto</h1>
        <p className="text-[#94a3b8]">Mensajes recibidos del formulario de contacto</p>
      </div>

      {loading ? (
        <div className="flex justify-center py-20">
          <div className="w-8 h-8 border-2 border-[#3b82f6] border-t-transparent rounded-full animate-spin" />
        </div>
      ) : (
        <div className="space-y-4">
          {contacts.map((contact) => (
            <div key={contact.id} className="glass-card p-6">
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="text-white font-semibold text-lg">{contact.name}</h3>
                  <div className="flex items-center gap-4 mt-1 text-sm text-[#94a3b8]">
                    <span className="flex items-center gap-1">
                      <Mail className="w-4 h-4" />
                      {contact.email}
                    </span>
                    {contact.company && (
                      <span className="flex items-center gap-1">
                        <Building className="w-4 h-4" />
                        {contact.company}
                      </span>
                    )}
                    {contact.phone && (
                      <span className="flex items-center gap-1">
                        <Phone className="w-4 h-4" />
                        {contact.phone}
                      </span>
                    )}
                  </div>
                </div>
                <div className="flex items-center gap-1 text-[#94a3b8] text-sm">
                  <Calendar className="w-4 h-4" />
                  {new Date(contact.created_at).toLocaleDateString('es-ES')}
                </div>
              </div>
              <p className="text-[#94a3b8] whitespace-pre-wrap">{contact.message}</p>
            </div>
          ))}
          
          {contacts.length === 0 && (
            <div className="text-center py-20 text-[#94a3b8]">
              No hay mensajes de contacto.
            </div>
          )}
        </div>
      )}
    </motion.div>
  );
};

export default ContactsView;
